// src/components/common/ConfirmCalendarDialog.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Collapse,
  Divider,
  Box,
} from "@mui/material";

export default function ConfirmCalendarDialog({
  open,
  title,
  content,
  onCancel,
  onConfirm,
  confirmText = "Aceptar",
  cancelText = "Cancelar",
  extra = null,              // Nodo opcional con info adicional (overview, etc.)
  maxWidth = "xs",
  fullWidth = true,
}) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth={maxWidth} fullWidth={fullWidth}>
      {title ? <DialogTitle>{title}</DialogTitle> : null}

     <DialogContent dividers>
        {content
          ? (typeof content === "string"
              ? <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>{content}</Typography>
              : content /* ← ahora acepta JSX */)
          : null}
        <Collapse in={Boolean(extra)}>
          {extra ? (
            <>
              {content ? <Divider sx={{ my: 1.5 }} /> : null}
              <Box sx={{ mt: content ? 0 : 0.5 }}>{extra}</Box>
            </>
          ) : null}
        </Collapse>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} variant="outlined">
          {cancelText}
        </Button>
        <Button onClick={onConfirm} variant="contained">
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
 